module.exports = __webpack_public_path__ + "img/N360.f759e28d.svg";